import React, { FC } from 'react';
import CMPImage from 'components/global/image';
interface Props {
  wh?: number;
}
const CrystalExtractionIcon: FC<Props> = ({ wh }) => {
  return (
    <CMPImage
      asset={{
        src: `${process.env.PUBLIC_URL}/images/professions/Crystal_Extraction.png`,
        alt: 'Crystal Extraction',
      }}
      width={wh || 64}
      height={wh || 64}
    />
  );
};

export default CrystalExtractionIcon;
